import { call, put } from "redux-saga/effects";

import { apiRouting, notify } from "services";
import { IFechRequest } from "interfaces/fetch-duck";
import { requestErrorHandler } from "utils";
import { FetchPickingQuarentineActions } from "store/ducks/picking-quarentines";

export function* fetchPickingQuarentineRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(apiRouting.get, `/picking-quarentines/${id}`);

    yield put(FetchPickingQuarentineActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(FetchPickingQuarentineActions.failure(errorMessage));
  }
}
